import {
  GetCustomerProfileQuery,
  GetCustomersQuery,
  SortEnumType,
  useGetCustomerProfileQuery,
  useGetCustomersQuery,
} from 'generated/graphql'
import { usePermission } from 'providers'

export interface BookingCustomer {
  id: string
  isUlezCharge: boolean
}

interface UseBookingCustomerReturn {
  customer: BookingCustomer | null
}

export const useBookingCustomer = (customerId?: string): UseBookingCustomerReturn => {
  const [isAllowedToViewCustomers] = usePermission('ViewCustomerList')
  const [isAllowedToViewCustomerProfile] = usePermission('ViewCustomerProfile')

  const { data: customersData } = useGetCustomersQuery({
    fetchPolicy: 'cache-first',
    variables: { order: { name: SortEnumType.Asc } },
    skip: !customerId || !isAllowedToViewCustomers,
  })

  const { data: profileData } = useGetCustomerProfileQuery({
    fetchPolicy: 'cache-first',
    skip: !customerId || !isAllowedToViewCustomerProfile || isAllowedToViewCustomers,
  })

  let customer: BookingCustomer | null = null

  if (isAllowedToViewCustomers) {
    const customers = customersData?.customers as GetCustomersQuery['customers']
    const foundCustomer = customers?.find((c) => c.id === customerId)

    if (foundCustomer) {
      customer = {
        id: foundCustomer.id,
        isUlezCharge: foundCustomer.isUlezCharge,
      }
    }
  } else if (isAllowedToViewCustomerProfile) {
    const profile = profileData?.customerProfile as GetCustomerProfileQuery['customerProfile']

    if (profile) {
      customer = {
        id: profile.customerId,
        isUlezCharge: profile.isUlezCharge,
      }
    }
  }

  return {
    customer,
  }
}
